import { useAgentContainer } from '@/context/agent-container.context';
import { ChatAgentRenderer } from './ChatAgentRenderer';

/** Keep module-owned conversations separate from personal chat state. */
export function ModuleChatAgentRenderer() {
  const { effectiveModuleConfig } = useAgentContainer();
  if (effectiveModuleConfig?.customRenderer) return null;
  return <ChatAgentRenderer />;
}
